module.exports = __webpack_public_path__ + "static/img/env12.30ea560.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env12.png
// module id = 105
// module chunks = 4